import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/src/app/[variants]/(staitc-page)/student-discount/components/MightLike.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/src/app/[variants]/(staitc-page)/student-discount/components/StudentBeansWidget.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/src/components/RouteMessagesProvider.tsx");
